import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';

const fetchLessons = async (courseId) => {
  const res = await axios.get(`/lessons/course/${courseId}`);
  return res.data;
};

const fetchLesson = async (id) => {
  const res = await axios.get(`/lessons/${id}`);
  return res.data;
};

export default function LessonPage() {
  const { id } = useParams();
  const [currentLessonId, setCurrentLessonId] = React.useState(null);
  
  const { data: lessonsData } = useQuery(['lessons', id], () => fetchLessons(id));
  const lessons = useMemo(() => lessonsData?.data || [], [lessonsData]);
  
  const { data: lessonData } = useQuery(
    ['lesson', currentLessonId],
    () => fetchLesson(currentLessonId),
    { enabled: !!currentLessonId }
  );
  const currentLesson = lessonData?.data;

  // auto-select first lesson
  React.useEffect(() => {
    if (lessons.length > 0 && !currentLessonId) {
      setCurrentLessonId(lessons[0]._id);
    }
  }, [lessons, currentLessonId]);

  return (
    <div className="flex h-[calc(100vh-64px)]">
      {/* Sidebar: Lesson List */}
      <div className="w-80 bg-white border-r overflow-y-auto">
        <div className="p-4 border-b">
          <h2 className="font-bold">บทเรียน</h2>
        </div>
        {lessons.map((lesson, idx) => (
          <button
            key={lesson._id}
            onClick={() => setCurrentLessonId(lesson._id)}
            className={`w-full text-left p-4 border-b hover:bg-gray-50 transition ${
              currentLessonId === lesson._id ? 'bg-blue-50 border-l-4 border-l-blue-600' : ''
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-400">{idx + 1}</span>
              <div>
                <p className="font-medium text-sm">{lesson.title}</p>
                <p className="text-xs text-gray-500">{lesson.contentType}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="flex-grow overflow-y-auto p-8">
        {currentLesson ? (
          <div>
            <h1 className="text-2xl font-bold mb-4">{currentLesson.title}</h1>
            <p className="text-gray-600 mb-6">{currentLesson.description}</p>
            
            {currentLesson.contentType === 'video' && currentLesson.videoUrl && (
              <div className="aspect-video bg-black rounded-xl mb-6">
                <video src={currentLesson.videoUrl} controls className="w-full h-full rounded-xl" />
              </div>
            )}
            
            {currentLesson.contentType === 'text' && (
              <div className="prose max-w-none bg-white p-6 rounded-xl border" dangerouslySetInnerHTML={{ __html: currentLesson.textContent }} />
            )}
            
            {currentLesson.contentType === 'pdf' && currentLesson.pdfUrl && (
              <div className="bg-white p-6 rounded-xl border">
                <a href={currentLesson.pdfUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                  ดาวน์โหลด PDF
                </a>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center text-gray-500">เลือกบทเรียน</div>
        )}
      </div>
    </div>
  );
}
